import ActionButton from "@/components/Button/ActionButton";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { UnescapedTrans } from "@/lib/i18n";

type ImageDialogProps = {
  title: string;
  image: {
    url: string;
    alt: string;
  };
};

const ImageDialog = ({ title, image }: ImageDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger>
        <ActionButton variant="outline" icon="ImageIcon" iconColor="muted" />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <UnescapedTrans>{title}</UnescapedTrans>
          </DialogTitle>
        </DialogHeader>
        <img src={image.url} alt={image.alt} />
      </DialogContent>
    </Dialog>
  );
};

export default ImageDialog;
